/**
 * The content view mode.
 * @param {'carousel'} Carousel
 * @param {'page'} Page
 */
export enum ViewMode {
  Carousel = 'carousel',
  Page = 'page',
}

/**
 * The props interface of a task progress component.
 */
export interface TaskProgressProps {

  /**
   * The default view mode.
   * @type {ViewMode | undefined}
   */
  defaultMode?: ViewMode;

}

/**
 * The interface of a task progress context.
 * @param {states} states
 */
export interface TaskProgressContext {

  /**
   * The states of a task progress.
   * @type {states} states
   */
  states: {

    /**
     * The mode state.
     * @type {mode} mode
     */
    mode: {

      /**
       * The state of the mode.
       * @type {ViewMode}
       */
      state: ViewMode;

      /**
       * Set state of the mode.
       * @param {ViewMode} state
       */
      setState(state: ViewMode): void;

    };

  };

}

/**
 * The props interface of a context provider.
 * @param {TaskProgressContext} value
 * @param {JSX.Element | JSX.Element[]} children
 */
export interface ContextProviderProps {

  /**
   * The context value.
   * @type {TaskProgressContext}
   */
  value: TaskProgressContext;

  /**
   * Children content.
   * @type {JSX.Element | JSX.Element[]}
   */
  children: JSX.Element | JSX.Element[];

}
